import React from 'react';
import './LogOutButton.scss';
import {useHistory} from 'react-router';
import {useDispatch} from 'react-redux';
import {Status} from '../../common/const/const';
import routes from '../../common/routes/routes';
import {logOut, sendError} from '../../common/redux/actions'

const LogOutButton = ({authService, switchStatus}) => {
    const history = useHistory();
    const dispatch = useDispatch();


    const onClick = React.useCallback(async() => {
        await authService.logOut().then(() => {
            dispatch(logOut());
            switchStatus(Status.UN_AUTHORIZED);
            history.push(routes.MAIN);

        }).catch(error => {
            if ('message' in error) {
                dispatch(sendError(error))
            } else {
                dispatch(sendError(error.response.data))
            }
        });
    }, [authService, dispatch, history, switchStatus])

    return (
        <button onClick={onClick} type="button" className="LogOutButton__main">
            Выйти
        </button>
    )
}

export default LogOutButton
